// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"b3f9d313","530":"9d6a550f","688":"5a23e5f3"}[chunkId] + ".chunk.js";
};